// Beneficiary account status chip (§4.1): Activating / Limited / Active.
// Text and times always come from the server (mock), never the device clock.
import type { AccountStatusInfo } from '@/types/phase2.types';
import { formatShort } from '@/mock/clock';

const AccountStatusChip = ({ status }: { status: AccountStatusInfo }) => {
  if (status.status === 'ACTIVE') {
    return <span className="nova-ben-chip nova-ben-chip-ok">Active</span>;
  }
  if (status.status === 'ACTIVATING') {
    return <span className="nova-ben-chip nova-ben-chip-warn">Activating</span>;
  }
  const until = status.limitedUntil ? ` until ${formatShort(status.limitedUntil)}` : '';
  return (
    <span className="nova-ben-chip nova-ben-chip-warn">Limited ₹50,000{until}</span>
  );
};

export default AccountStatusChip;
